exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.relation_image[data-v-215658eb] {\n    max-width: 100%;\n    max-height: 200px;\n    border-radius: 50%;\n}\n.detail-buttons[data-v-215658eb] {\n    margin-bottom: 15px;\n    float: right;\n}\n.add_address[data-v-215658eb] {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n.action_icon[data-v-215658eb] {\n    cursor: pointer;\n    margin-right: 5px;\n}\n.address_block a[data-v-215658eb] {\n    margin-right: 10px;\n}\n", ""]);

// exports
